import dayjs from "dayjs/esm/index.js";
import { Languages, isLanguage } from "waapi/front-utils/hooks/useTranslation/types.js";
import { DAYJS_LOCALE_MAP } from "../app/providers/translations/constants.js";
import { setLanguage } from "../services/ChromeMessaging/Translations/setLanguage.js";

export const changeAppLanguage = ({
    newLanguage,
    changeI18nLanguage,
    extensionId,
    currentLanguage,
    persistToBackend,
}: {
    newLanguage?: string;
    changeI18nLanguage: (Language: Languages) => void;
    extensionId?: string;
    currentLanguage: string;
    persistToBackend?: (language: Languages) => void;
}) => {
    if (newLanguage === undefined || newLanguage === currentLanguage) return;

    const languageToUse = isLanguage(newLanguage) ? newLanguage : Languages.EN;

    dayjs.locale(DAYJS_LOCALE_MAP[languageToUse]);
    changeI18nLanguage(languageToUse);

    if (extensionId) setLanguage(extensionId, { language: languageToUse });

    persistToBackend?.(languageToUse);
};
